import React from 'react'
import { FaLayerGroup } from "react-icons/fa";
import { FaRegTrashCan } from "react-icons/fa6";

export const DrawingElement = (
  {
    drawing,
    isEditActive,
    currentUnionHash,
    onSelectDrawing,
    currentDrawingCode,
    selectedDrawingsID,
    selectedDrawings,
    onSetEditMode,
    existsUnionEdit,
    setHoveredUnionHash,
    hoveredUnionHash,
    onUnionDelete,
    isHeadOfProduction
  }
) => {
  const { id, name, union_hash, code } = drawing
  const isSelected = !!selectedDrawings[id]

  //Блокируем если уже выбран метод, а текущий не соотв. выбранному по типу
  const isBlockByDrawingCode = currentDrawingCode
    ? code !== currentDrawingCode
    : false

  //Блокируем если уже выбран 1 метод в позиции и это не данный
  const isBlockByPosition = !!selectedDrawingsID && selectedDrawingsID !== id

  //Блокируем при true в любом из двух условий выше
  const isBlockDrawing = isBlockByDrawingCode || isBlockByPosition

  //При создании новой группы а не редактировании существующей блокируем
  //по условию isBlockDrawing или при наличии union_hash, что говорит о том что этот метод уже в некоторой группе
  const isBlockOnNewUnionCreate = isBlockDrawing || !!union_hash

  //При редактировании существующей группы блокируем те, у которых union_hash существует но отличается от
  //union_hash выбранной группы
  //или метод печати не совпадает с выбранными по типу
  const isBlockOnExistsUnionEdit = !!union_hash && (union_hash !== currentUnionHash) || isBlockDrawing

  const currentBlock = !existsUnionEdit ? isBlockOnNewUnionCreate : isBlockOnExistsUnionEdit
  const isShowPreviewUnion = !!union_hash && hoveredUnionHash === union_hash

  const onClickHandle = () => {
    if (isEditActive) {
      const selectedData = {
        id,
        code
      }
      onSelectDrawing(selectedData)
    } else if (!isEditActive && union_hash && isHeadOfProduction) {
      onSetEditMode({
        isInitOpen: false,
        selectedUnionHash: union_hash,
        selectedDrawingCode: code,
      })()
    }
  }

  const onMouseEnterHandler = (e) => {
    if(!union_hash || isEditActive) return;
    setHoveredUnionHash(union_hash)
  }
  const onMouseLeaveHandler = () => {
    if(!union_hash || isEditActive) return;
    setHoveredUnionHash(null)
  }

  const onDeleteUnion = (e) => {
    e.stopPropagation()
    onUnionDelete(union_hash)
  }

  return (
    <div className={`flex items-center justify-between h-[3.4rem] px-[1rem] transition
    ${isEditActive || union_hash ? 'hover:bg-Accent/Light_Yellow hover:cursor-pointer' : ''}
    ${isShowPreviewUnion ? 'bg-Accent/Light_Yellow' : ''}
    ${isEditActive && currentBlock ? 'pointer-events-none text-Accent/Rose' : ''}
    `} onClick={onClickHandle}
         onMouseEnter={onMouseEnterHandler}
         onMouseLeave={onMouseLeaveHandler}
    >
      <span className={`text-Regular(16_18) line-clamp-1 ${isShowPreviewUnion ? 'font-bold' : ''}`}>
        {name}
      </span>
      {isEditActive && !currentBlock && <div className={`rounded-[50%] bg-white border border-Accent/Yellow 
        w-[2rem] h-[2rem] flex items-center justify-center
       ${isSelected ? 'before:rounded-[50%] before:h-[1.2rem] before:w-[1.2rem] before:bg-Accent/Yellow' : ''}
       `}>
      </div>}
      {!isEditActive && union_hash &&
        <div className={`flex gap-[1rem]`}>
          {isShowPreviewUnion && isHeadOfProduction && <div className={`rounded-[50%] bg-white border
            border-Accent/Blue w-[2rem] h-[2rem] flex items-center justify-center
            hover:cursor-pointer hover:border-Accent/Red group`}
            onClick={onDeleteUnion}
          >
            <FaRegTrashCan className={`fill-Accent/Blue group-hover:fill-Accent/Red`} />
          </div>
          }
          <div className={`rounded-[50%] bg-white border 
       ${isShowPreviewUnion ? 'border-Accent/Yellow' : 'border-Accent/Blue'}
        w-[2rem] h-[2rem] flex items-center justify-center`}>
            <FaLayerGroup className={`${isShowPreviewUnion
              ? 'fill-Accent/Yellow'
              : 'fill-Accent/Blue'}`} />
          </div>
        </div>}
    </div>
  )
}